<template>
  <div>
    <div v-if="fieldProperties.field_property.mode == 1">
      <span
        :style="{ fontSize: '20px' }"
        :class="fieldProperties.required ? 'required' : false"
        >{{
          $i18n.t == 'th' ? fieldProperties.label_th : fieldProperties.label_en
        }}</span
      >
      <b-form-checkbox
        fieldValue="true"
        class="custom-control-success custom-toggle"
        name="check-button"
        switch
        v-model="fieldValue"
      >
        <span class="switch-icon-left toggle-text">{{
          $i18n.t == 'th' ? optionList[0].name_th : optionList[0].name_en
        }}</span>
        <span class="switch-icon-right toggle-text">{{
          $i18n.t == 'th' ? optionList[1].name_th : optionList[1].name_en
        }}</span>
      </b-form-checkbox>
    </div>
    <div v-if="fieldProperties.field_property.mode == 2">
      <b-row>
        <b-col cols="12">
          <b-form-checkbox
            fieldValue="true"
            class="custom-control-success custom-toggle"
            name="check-button"
            switch
            v-model="fieldValue"
          >
            <span class="switch-icon-left toggle-text">{{
              $i18n.t == 'th' ? optionList[0].name_th : optionList[0].name_en
            }}</span>
            <span class="switch-icon-right toggle-text">{{
              $i18n.t == 'th' ? optionList[1].name_th : optionList[1].name_en
            }}</span>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" class="mt-2">
          <span
            :style="{ fontSize: '20px' }"
            :class="fieldProperties.required ? 'required' : false"
            >{{
              $i18n.t == 'th'
                ? fieldProperties.key
                : fieldProperties.key
            }}</span
          >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="CircleIcon"
              size="10"
              class="mr-2"
              :style="{
                fill: fieldValue
                  ? optionList[0].color_icon
                  : optionList[1].color_icon,
                color: fieldValue
                  ? optionList[0].color_icon
                  : optionList[1].color_icon,
              }"
            />
            <span :style="statusStyle" class="status-text">{{
              fieldValue
                ? $i18n.t == 'th'
                  ? optionList[0].label_th
                  : optionList[0].label_en
                : $i18n.t == 'th'
                ? optionList[1].label_th
                : optionList[1].label_en
            }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { BFormCheckbox, BRow, BCol } from 'bootstrap-vue';
  import { ref, onBeforeMount, computed, watch } from '@vue/composition-api';
  import { toggleField } from '@/configs/dynamic-config/dynamic-field';

  export default {
    components: { BFormCheckbox, BRow, BCol },
    props: { fieldProperties: Object },

    setup(props) {
      const fieldValue = ref(props.fieldProperties.value || false);
      const optionList = ref([...props.fieldProperties.field_property.value]);

      const orderChoice = () => {
        optionList.value.sort(
          (option1, option2) => option2.value - option1.value
        );
      };

      const statusStyle = computed(() => {
        return {
          color: fieldValue.value
            ? optionList.value[0].color_font || toggleField.color_font
            : optionList.value[1].color_font || toggleField.color_font,
          fontSize: fieldValue.value
            ? optionList.value[0].font_size || toggleField.fontSize
            : optionList.value[1].font_size || toggleField.fontSize,
        };
      });

      onBeforeMount(() => {
        orderChoice();
      });

      watch(
        () => props.fieldProperties,
        (newVal, oldVal) => {
          fieldValue.value = props.fieldProperties.value;
          optionList.value = [...props.fieldProperties.field_property.value];
          orderChoice();
        },
        { deep: true }
      );

      return { fieldValue, optionList, statusStyle };
    },
  };
  2;
</script>

<style></style>

<style scoped>
  @import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
